import React, { FC } from 'react';
import { stripHtmlStrings } from '../../shared/stripHTMLStrings';
import './SectionText.scss';

export interface ISectionText {
    isAboutText?: boolean;
    heading?: string;
    body: string;
}
export const SectionText: FC<{ inputs: ISectionText }> = ({ inputs }) => {
    const { isAboutText, heading, body } = inputs;
    const renderHeading = stripHtmlStrings(heading);

    if (isAboutText) {
        return (
            <div className="section-text section-text--about">
                {heading && <h2>{renderHeading}</h2>}
                <div dangerouslySetInnerHTML={{ __html: body }} />
            </div>
        );
    }

    return (
        <div className="section-text">
            {heading && <h3>{renderHeading}</h3>}
            <div dangerouslySetInnerHTML={{ __html: body }} />
        </div>
    );
};
